<div class="time-picker-input-wrapper fade-in-bottom">
  <app-time-picker-control #timePicker [formControl]="formControl"></app-time-picker-control>
</div>
